export default __webpack_public_path__ + "static/media/logo-footer.98508d28.png";